import {
  ApolloClient,
  gql,
  NormalizedCacheObject,
  useQuery,
} from '@apollo/client';
import {Query} from '../types/generated/graphql';

/**
 * The ranked insight candidate list the engagement engine builds for a profile
 * when deciding which insight to notify — every scanned video with its score
 * breakdown and the reason for its place/order (or exclusion). Read-only audit
 * of the selection algorithm. Backed by the `adminInsightCandidates` resolver,
 * which runs the SAME explain path the engine uses to pick.
 */
export const useAdminInsightCandidates = (
  client: ApolloClient<NormalizedCacheObject>,
  profileId: string,
) => {
  type T = Pick<Query, 'adminInsightCandidates'>;
  return useQuery<T, {profileId: string}>(QUERY, {
    client,
    variables: {profileId},
    fetchPolicy: 'cache-and-network',
    skip: !profileId,
  });
};

const QUERY = gql`
  query adminInsightCandidates($profileId: ID!) {
    adminInsightCandidates(profileId: $profileId) {
      profileId
      profileName
      scanned
      includedCount
      excludedCount
      chosenVideoId
      notes
      candidates {
        videoId
        title
        channelName
        aiRating
        aiConfidence
        aiScore
        lastWatchAt
        included
        severity
        tone
        rank
        score
        scoreBase
        scoreRecency
        scoreCapped
        alreadyNotified
        rankPosition
        reason
      }
    }
  }
`;
